/** Default data used by the optimiser */
const OptimiserDefaultData = {
  battery: 38,
  modelId: "776ccc2c-8458-4718-af68-97bc8ad56ddd",
  SOCAct: 1,
  SOCMin: 0.1,
  SOCMax: 0.9,
  SOCEnd: 0.2,
  relativeSpeed: 0,
  petrolCostPerLitre: 3,
  petrolKmPerLitre: 9.24,
  dieselCostPerLitre: 2.8,
  dieselKmPerLitre: 12,
  roadUserCharges: 76,
  kWhCostHome: 0.26,
  kWhCostPublic: 0.80,
  electricityCostPerMinPublic: 0,
  perAnnumMaintenanceCurrentV: 2000,
  perAnnumMaintenanceEV: 500,
  electric_CO2_kg_per_kWh: 0.13,
  hydrogen_road_user_charges: 75,
  hydrogen_cost_per_kg: 10,
  hydrogen_maintenance_per_annum: 2500,
  hydrogen_CO2_kg_per_kg: 10,
};

export default OptimiserDefaultData;
